import { EventInput } from '@fullcalendar/core';
import { CalendarEvent, Task, WeekDays } from '@griply/types';

import { CalendarEventExtendedProps } from './extended-props';

export const mapCalendarEventToEventInput = (
  event: CalendarEvent,
  task: Task | undefined,
  weekStartsOn: WeekDays,
): EventInput => ({
  id: event.id,
  date: event.date,
  start: event.start.dateTime ? new Date(event.start.dateTime) : undefined,
  end: event.end.dateTime ? new Date(event.end.dateTime) : undefined,
  title: event.title,
  allDay: event.allDay,
  extendedProps: {
    taskId: event.taskId,
    goalId: event.goalId,
    occurrenceId: event.occurrenceId,
    isDeadline: event.isDeadline,
    showDeadlineFlag: event.showDeadlineFlag,
    duration: event.duration,
    completed: event.completed,
    checkOption: event.checkOption,
    isFutureRepeating: event.isFutureRepeating,
    // load-bearing for eventAllowHabit's one-per-date guard — dropping either silently breaks habit drops
    task,
    weekStartsOn,
  } satisfies CalendarEventExtendedProps,
});
